import React from 'react';
import { HeroSection } from '../components/home/HeroSection';
import { TrustBadges } from '../components/home/TrustBadges';
import { AboutSummary } from '../components/home/AboutSummary';
import { StatsSection } from '../components/home/StatsSection';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ServiceCard } from '../components/shared/ServiceCard';
import { Building2, Hammer, PenTool, Shield, ArrowRight } from 'lucide-react';
export function HomePage() {
  const featuredServices = [{
    icon: <Building2 size={40} strokeWidth={1.5} data-id="element-396" />,
    title: 'Building Construction',
    description: 'Comprehensive construction services for residential, commercial, and institutional projects with world-class standards.'
  }, {
    icon: <Hammer size={40} strokeWidth={1.5} data-id="element-397" />,
    title: 'Civil Engineering',
    description: 'Expert civil engineering solutions including drainage systems, earthworks, and infrastructure development.'
  }, {
    icon: <PenTool size={40} strokeWidth={1.5} data-id="element-398" />,
    title: 'Design & Build',
    description: 'Integrated design and construction services with 3D visualization and comprehensive MEP engineering.'
  }, {
    icon: <Shield size={40} strokeWidth={1.5} data-id="element-399" />,
    title: 'Project Management',
    description: 'Professional project management and consultancy services ensuring timely delivery and cost efficiency.'
  }];
  return <div className="min-h-screen" data-id="element-400">
      <HeroSection data-id="element-401" />
      <TrustBadges data-id="element-402" />
      <StatsSection data-id="element-403" />
      <AboutSummary data-id="element-404" />

      {/* Featured Services */}
      <section className="py-16 sm:py-20 md:py-24 lg:py-32 bg-white" data-id="element-405">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-406">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center mb-12 sm:mb-16" data-id="element-407">
            <h2 className="font-heading font-semibold text-3xl sm:text-4xl md:text-5xl text-charcoal mb-3 sm:mb-4" data-id="element-408">
              Our Services
            </h2>
            <p className="text-stone text-base sm:text-lg max-w-2xl mx-auto px-4" data-id="element-409">
              Comprehensive construction and engineering solutions tailored to
              your needs
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-12" data-id="element-410">
            {featuredServices.map((service, index) => <ServiceCard key={index} icon={service.icon} title={service.title} description={service.description} index={index} data-id="element-411" />)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="text-center" data-id="element-412">
            <Link to="/services" data-id="element-413">
              <motion.button whileHover={{
              backgroundColor: '#D4B896'
            }} whileTap={{
              scale: 0.98
            }} className="group px-6 sm:px-8 py-3 sm:py-4 bg-gold text-charcoal font-semibold text-sm sm:text-[15px] transition-colors inline-flex items-center gap-2" data-id="element-414">
                View All Services
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" strokeWidth={2} data-id="element-415" />
              </motion.button>
            </Link>
          </motion.div>
        </div>
      </section>
    </div>;
}